import { LoadingKey } from './key'
import ContentLoader from './react-content-loader'

const VideoSpotlightsLoading = ({
  count = 3,
  viewBoxValue = '0 0 632 300'
}) => {
  return (
    <ContentLoader
      viewBox={viewBoxValue}
      uniqueKey={LoadingKey.videoSpotlights}
      foregroundColor='var(--background-1st)'
      backgroundColor='var(--background-2nd)'
      speed={1.5}
      interval={0.5}
      gradientRatio={1}
    >
      {Array.from({ length: count }).map((_, index) => (
        <rect
          x={198 * index}
          y={0}
          rx='12'
          ry='12'
          width='190'
          height='285'
          key={index}
        />
      ))}
    </ContentLoader>
  )
}

export default VideoSpotlightsLoading
